// musi byt prvni - cestina pro dayjs
import "./utils/dayjs-locale";
import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Page from "~/components/Page";
import { ROUTES } from "~/const-files/const";

import { setDefaultBackground } from "./utils/assets";
import { savedStoreInit } from "./stores/saved";
import { debugStoreInit } from "./stores/debug";

// css/less
import './index.less';

const MainPage = lazy(() => import("~/pages/MainPage"));
const MessengerPage = lazy(() => import("~/pages/MessengerPage"));
const OverviewPage = lazy(() => import("~/pages/OverviewPage"));
const DancePage = lazy(() => import("~/pages/DancePage"));
const GalleryPage = lazy(() => import("~/pages/GalleryPage"));
const LoginPage = lazy(() => import("~/pages/LoginPage"));
const OthersPage = lazy(() => import("~/pages/OthersPage"));
const CalendarPage = lazy(() => import("~/pages/CalendarPage"));
const InThisDayPage = lazy(() => import("~/pages/InThisDayPage"));
const TracksPage = lazy(() => import("./pages/TracksPage"));
const WorldMapPage = lazy(() => import("./pages/WorldMapPage"));
const SearchPage = lazy(() => import("./pages/SearchPage"));
const UploadPage = lazy(() => import("./pages/UploadPage"));
const VisitsPage = lazy(() => import("./pages/VisitsPage"));
const SalaryPage = lazy(() => import("./pages/SalaryPage"));
const UploadedFilesPage = lazy(() => import("./pages/UploadedFilesPage"));
const StoryPage = lazy(() => import("./pages/StoryPage"));
const BirthdaysPage = lazy(() => import("./pages/BirthdaysPage"));
const SnakePage = lazy(() => import("./pages/SnakePage"));
const DataContentPage = lazy(() => import("./pages/DataContentPage"));
const PaymentPage = lazy(() => import("./pages/PaymentPage"));
const Lenka2024Page = lazy(() => import("./pages/Lenka2024Page"));
const DatabaseItemsPage = lazy(() => import("./pages/DatabaseItemsPage"));
const ImageTesterPage = lazy(() => import("./pages/ImageTester"));
const GuessPage = lazy(() => import("./pages/GuessPage"));
const ChangelogPage = lazy(() => import("./pages/ChangelogPage"));
const FamilyTreePage = lazy(() => import("./pages/FamilyTreePage"));
const HolidaysPage = lazy(() => import("./pages/HolidaysPage"));
const LinksPage = lazy(() => import("./pages/LinksPage"));
const MortagePage = lazy(() => import("./pages/MortagePage"));
const TraitorsPage = lazy(() => import("./pages/TraitorsPage"));
const KiaPage = lazy(() => import("./pages/KiaPage"));
const FirstDayPage = lazy(() => import("./pages/FirstDayPage"));
const GrowthPage = lazy(() => import("./pages/GrowthPage"));
const TitlePhotosPage = lazy(() => import("./pages/TitlePhotosPage"));
const FacesPage = lazy(() => import("./pages/FacesPage"));
const ToysPage = lazy(() => import("./pages/ToysPage"));
const ChristmasTagsPage = lazy(() => import("./pages/ChristmasTagsPage"));
const PortraitsPage = lazy(() => import("./pages/PortraitsPage"));
const MissingPortraitsPage = lazy(() => import("./pages/MissingPortraitsPage"));

setDefaultBackground();
savedStoreInit("makuderovi");
debugStoreInit("makuderovi");

const container = document.getElementById('app') || document.body;
const root = createRoot(container);

// fix proti roztahovani obrazovky
document.addEventListener("touchmove", event => {
	if (event.scale !== 1 && event.touches.length > 1) {
		event.preventDefault();
	}
}, { passive: false });

// render
root.render(
	<Router>
		<Suspense fallback={null}>
			<Routes>
				<Route element={<Page />}>
					<Route path={ROUTES.OVERVIEW} element={<OverviewPage />} />
					<Route path={ROUTES.MESSENGER} element={<MessengerPage />} />
					<Route path={ROUTES.DANCE} element={<DancePage />} />
					<Route path={ROUTES.GALLERY} element={<GalleryPage />} />
					<Route path={ROUTES.GALLERY_DETAIL} element={<GalleryPage />} />
					<Route path={ROUTES.LOGIN} element={<LoginPage />} />
					<Route path={ROUTES.OTHERS} element={<OthersPage />} />
					<Route path={ROUTES.CALENDAR} element={<CalendarPage />} />
					<Route path={ROUTES.TRACKS} element={<TracksPage />} />
					<Route path={ROUTES.WORLD_MAP} element={<WorldMapPage />} />
					<Route path={ROUTES.IN_THIS_DAY} element={<InThisDayPage />} />
					<Route path={ROUTES.SEARCH} element={<SearchPage />} />
					<Route path={ROUTES.SEARCH_EVENTS_OLD} element={<SearchPage redirectTab="events" />} />
					<Route path={ROUTES.SEARCH_PHOTOS_OLD} element={<SearchPage redirectTab="photos" />} />
					<Route path={ROUTES.SEARCH_PHOTOS_AGE_OLD} element={<SearchPage redirectTab="photos" />} />
					<Route path={ROUTES.UPLOAD} element={<UploadPage />} />
					<Route path={ROUTES.UPLOADED_FILES} element={<UploadedFilesPage />} />
					<Route path={ROUTES.VISITS} element={<VisitsPage />} />
					<Route path={ROUTES.SALARY} element={<SalaryPage />} />
					<Route path={ROUTES.STORY_DETAIL} element={<StoryPage />} />
					<Route path={ROUTES.STORY} element={<StoryPage />} />
					<Route path={ROUTES.BIRTHDAYS} element={<BirthdaysPage />} />
					<Route path={ROUTES.SNAKE} element={<SnakePage />} />
					<Route path={ROUTES.DATA_CONTENT} element={<DataContentPage />} />
					<Route path={ROUTES.PAYMENTS} element={<PaymentPage />} />
					<Route path={ROUTES.LENKA_2024} element={<Lenka2024Page />} />
					<Route path={ROUTES.DATABASE_ITEMS} element={<DatabaseItemsPage />} />
					<Route path={ROUTES.IMAGE_TESTER} element={<ImageTesterPage />} />
					<Route path={ROUTES.GUESS} element={<GuessPage />} />
					<Route path={ROUTES.CHANGELOG} element={<ChangelogPage />} />
					<Route path={ROUTES.FAMILY_TREE} element={<FamilyTreePage />} />
					<Route path={ROUTES.HOLIDAYS} element={<HolidaysPage />} />
					<Route path={ROUTES.LINKS} element={<LinksPage />} />
					<Route path={ROUTES.MORTAGE} element={<MortagePage />} />
					<Route path={ROUTES.KIA} element={<KiaPage />} />
					<Route path={ROUTES.FIRST_DAY} element={<FirstDayPage />} />
					<Route path={ROUTES.GROWTH} element={<GrowthPage />} />
					<Route path={ROUTES.TITLE_PHOTOS} element={<TitlePhotosPage />} />
					<Route path={ROUTES.FACES} element={<FacesPage />} />
					<Route path={ROUTES.TOYS} element={<ToysPage />} />
					<Route path={ROUTES.CHRISTMAS_TAGS} element={<ChristmasTagsPage />} />
					<Route path={ROUTES.PORTRAITS} element={<PortraitsPage />} />
					<Route path={ROUTES.MISSING_PORTRAITS} element={<MissingPortraitsPage />} />
					<Route path="*" element={<MainPage />} />
				</Route>
				<Route>
					<Route path={ROUTES.TRAITORS} element={<TraitorsPage />} />
				</Route>
			</Routes>
		</Suspense>
	</Router>,
);
